import { c as _c } from "react/compiler-runtime";
import { QueryParams } from "@router/route-params";
import { setIsAlphaTestingEnabled, setIsBetaTestingEnabled, setIsDevModeEnabled } from "@store/app/app-slice";
import { setIsTranslationOverrideAllowed } from "@store/dev-features/dev-features-slice";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { loggedInUserSelector } from "@store/user/user-selector";
import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { EmailUtils } from "@stellar/utils";

/**
 * Component that validates whether a query param exist or not all over the app
 * For example, it can be used to check whether "alpha" or "beta" features are enable or not
 */
export function QueryParamsLoader(t0) {
  const $ = _c(28);
  const {
    children
  } = t0;
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const loggedInUser = useAppSelector(loggedInUserSelector);
  let t1;
  if ($[0] !== loggedInUser) {
    t1 = loggedInUser && EmailUtils.isInternalUser(loggedInUser.email);
    $[0] = loggedInUser;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isUserInternal = t1;
  let t2;
  if ($[2] !== searchParams) {
    t2 = searchParams.get(QueryParams.enableBeta);
    $[2] = searchParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const enableBetaParam = t2;
  let t3;
  if ($[4] !== searchParams) {
    t3 = searchParams.get(QueryParams.enableAlpha);
    $[4] = searchParams;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const enableAlphaParam = t3;
  let t4;
  if ($[6] !== searchParams) {
    t4 = searchParams.get(QueryParams.enableDev);
    $[6] = searchParams;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const enableDevParam = t4;
  let t5;
  if ($[8] !== searchParams) {
    t5 = searchParams.get(QueryParams.allowTranslationOverride);
    $[8] = searchParams;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const allowTranslationParam = t5;
  let t6;
  let t7;
  if ($[10] !== dispatch || $[11] !== enableBetaParam) {
    t6 = () => {
      if (!enableBetaParam) {
        return;
      }
      const lowerCaseStr = enableBetaParam.toLowerCase();
      dispatch(setIsBetaTestingEnabled(lowerCaseStr === "true"));
    };
    t7 = [dispatch, enableBetaParam];
    $[10] = dispatch;
    $[11] = enableBetaParam;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[14] !== dispatch || $[15] !== enableAlphaParam || $[16] !== isUserInternal) {
    t8 = () => {
      if (!enableAlphaParam || !isUserInternal) {
        return;
      }
      const lowerCaseStr_0 = enableAlphaParam.toLowerCase();
      dispatch(setIsAlphaTestingEnabled(lowerCaseStr_0 === "true"));
    };
    t9 = [dispatch, enableAlphaParam, isUserInternal];
    $[14] = dispatch;
    $[15] = enableAlphaParam;
    $[16] = isUserInternal;
    $[17] = t8;
    $[18] = t9;
  } else {
    t8 = $[17];
    t9 = $[18];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[19] !== dispatch || $[20] !== enableDevParam || $[21] !== isUserInternal) {
    t10 = () => {
      if (isUserInternal === null) {
        return;
      }
      const lowerCaseStr_1 = enableDevParam?.toLowerCase();
      dispatch(setIsDevModeEnabled(isUserInternal && lowerCaseStr_1 === "true"));
    };
    t11 = [dispatch, enableDevParam, isUserInternal];
    $[19] = dispatch;
    $[20] = enableDevParam;
    $[21] = isUserInternal;
    $[22] = t10;
    $[23] = t11;
  } else {
    t10 = $[22];
    t11 = $[23];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[24] !== allowTranslationParam || $[25] !== dispatch) {
    t12 = () => {
      if (!allowTranslationParam) {
        return;
      }
      const lowerCaseStr_2 = allowTranslationParam.toLowerCase();
      dispatch(setIsTranslationOverrideAllowed(lowerCaseStr_2 === "true"));
    };
    t13 = [dispatch, allowTranslationParam];
    $[24] = allowTranslationParam;
    $[25] = dispatch;
    $[26] = t12;
    $[27] = t13;
  } else {
    t12 = $[26];
    t13 = $[27];
  }
  useEffect(t12, t13);
  return children;
}